<script>
	import { navigate } from "svelte-routing";

	export let row = {};
	export let key = "";

	let { linkBy, linkTo } = $$props;
</script>

<button
	type="button"
	class="link link-text link-button"
	on:click={() => navigate(`${linkTo}${row[linkBy]}`)}
>
	{row[key]}
</button>

<style>
	.link-button {
		background: none;
		border: none;
		padding: 0;
		font: inherit;
		text-align: inherit;
		cursor: pointer;
	}
</style>
